module.exports = __webpack_public_path__ + "static/img/08ok.619d9639.webp";